// The homepage's drawn papers: a card stock to print on, and lines in that
// stock's own ink, so a paper reads on any stock, light or dark, in either theme.

// A paper printed on one of the design system's card stocks, in its ink
export const stock = (name) => ({ background: `hsl(var(--stock-${name}))`, color: `hsl(var(--stock-${name}-ink))` });

// A drawn line or field in the paper's own ink, at a strength
export const ink = (percent) => ({ background: `color-mix(in srgb, currentColor ${percent}%, transparent)` });
